<template lang="pug">
  modal.conditions-modal.column.middle.center(@closeModal='hideElement({ element: "termsAndConditionsModal" })')
    embed(:src='termsAndConditions' width="100%" height="400px")
</template>

<script>
import { mapState, mapActions } from 'vuex'

import Modal from '../Modal'

export default {
  components: { Modal },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.termsAndConditionsModal.props
    }),
    termsAndConditions() {
      return process.env.VUE_APP_TERMS_AND_CONDITIONS
    }
  },
  methods: {
    ...mapActions([ 'hideElement' ])
  }
}
</script>

<style lang="scss">
.conditions-modal .modal-container {
  --max-width: 700px;
}
</style>
